module.exports = function() {
	return new Worker(__webpack_public_path__ + "0065b3b65b579c817d46.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/worker-loader!./web.modules/coremail.framework/src/common/assets/index_cmxt50/js/blurImg_worker.js
 ** module id = 486
 ** module chunks = 15
 **/